import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA — register service worker (production only)
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/sw.js")
    .catch((err) => {
      // Silent fail: app keeps working even if SW registration fails.
      // eslint-disable-next-line no-console
      console.warn("[PWA] Service worker registration failed:", err);
    });
}
